import { render, staticRenderFns } from "./Nns.vue?vue&type=template&id=283e5c37"
import script from "./Nns.vue?vue&type=script&lang=js"
export * from "./Nns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports